module.exports = __webpack_public_path__ + "static/media/field-marketing.dc02f0d1.svg";